// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_t5-5";
export var filledCircle = "_t5-4";
export var historyEntry = "_t5-3";
export var messageSideLeft = "_t5-1";
export var messageSideRight = "_t5-2";
export var orderTrackingCarouselWrapper = "_t5-6";
export var orderTrackingInfoContainer = "_t5-0";